import React, { useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import ReportsActionBar from './components/ReportsActionBar'
import ReportTypesSection from './components/ReportTypesSection'
import RecentReportsTable from './components/RecentReportsTable'
import { getMockRecentReports, REPORT_CAMPAIGN_OPTIONS } from './mock/reports'

const ALL_REPORTS = getMockRecentReports()

function matchesPeriod(report, period) {
  if (!period.preset || period.preset === 'all_time') return true

  const generated = dayjs(report.generatedOnISO)

  if (period.preset === 'custom') {
    if (!period.from || !period.to) return true
    return !generated.isBefore(dayjs(period.from), 'day') && !generated.isAfter(dayjs(period.to), 'day')
  }

  const now = dayjs()

  switch (period.preset) {
    case 'today': return generated.isSame(now, 'day')
    case 'last_7_days': return generated.isAfter(now.subtract(7, 'day'), 'day')
    case 'last_30_days': return generated.isAfter(now.subtract(30, 'day'), 'day')
    case 'this_month': return generated.isSame(now, 'month')
    case 'last_month': return generated.isSame(now.subtract(1, 'month'), 'month')
    default: return true
  }
}

export default withTranslation()(function Reports({ t }) {
  const [period, setPeriod] = useState({ preset: 'all_time', from: '', to: '' })
  const [campaign, setCampaign] = useState('')

  const reports = useMemo(() => ALL_REPORTS.filter((report) => {
    if (campaign && report.campaignValue !== campaign) return false
    return matchesPeriod(report, period)
  }), [campaign, period])

  return (
    <section className="w-full max-w-6xl mx-auto pb-10">
      <ReportsActionBar
        period={period}
        onSelectPeriodPreset={(preset) => setPeriod({ preset, from: '', to: '' })}
        onApplyCustomPeriod={(from, to) => setPeriod({ preset: 'custom', from, to })}
        onClearPeriod={() => setPeriod({ preset: 'all_time', from: '', to: '' })}
        campaign={campaign}
        onChangeCampaign={setCampaign}
        campaignOptions={REPORT_CAMPAIGN_OPTIONS}
      />

      <ReportTypesSection
        onSelectType={() => {}}
        onCreateCustom={() => {}}
      />

      <RecentReportsTable
        reports={reports}
        onDownload={() => {}}
        onDelete={() => {}}
      />
    </section>
  )
})
